import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
  let button = document.querySelector('.hd_menu_btn');
  let nav_box = document.querySelector('.hd_nav_box');

  if (button && nav_box) {
    button.addEventListener('click', function() {

      if (nav_box.classList.contains('is_open')) {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      } else {
        nav_box.classList.add("is_open");
        button.classList.add("is_close");
      }

    });
  }

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

  const desktopHoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (desktopHoverMedia.matches) {
    links.forEach((link) => {
      let labelTimerId = null;
      const lockNavLabel = () => {
        link.classList.add('is-label-fixed');

        if (labelTimerId) {
          clearTimeout(labelTimerId);
        }

        link.classList.remove('is-label-animate');
        void link.offsetWidth;
        link.classList.add('is-label-animate');

        labelTimerId = setTimeout(() => {
          link.classList.remove('is-label-animate');
          labelTimerId = null;
        }, 460);
      };
      link.addEventListener('mouseenter', lockNavLabel);
      link.addEventListener('focus', lockNavLabel);
    });
  }

/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  function getHeaderHeight() {
    const header = document.querySelector('.header');
    return header ? header.offsetHeight : 0;
  }

  document.addEventListener('tccf7:scrollTo', e => {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: "#" + e.detail.id,
        offsetY: getHeaderHeight()
      },
      ease: "power2.inOut"
    });
  });

/*----------------------------------------
お問い合わせバリデーション
------------------------------------------*/
if(document.body.classList.contains("home")){
  topValidation('zip', 'address01', 'address02');
}

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('.header'); // ここでヘッダー要素を取得しています

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");

      const headerHeight = header ? header.offsetHeight : 0;

      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: 130
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});

/*----------------------------------------
MVアニメーション
------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const mvArea = document.querySelector('.mv');
  const mvImageArea = document.querySelector('.mv_image'); // 画像エリアの要素
  const indicatorArea = document.querySelector('.mv_indicator'); // インジケーターエリアの要素

  if (!mvArea || !mvImageArea || typeof mvData === 'undefined' || !mvData.items) return;

  const items = mvData.items;
  const imgs = mvImageArea.querySelectorAll('.mv_target_image'); // 画像要素のリスト
  const mvOverlayLink = document.querySelector('.mv_overlay_link'); // オーバーレイリンクの要素
  const metaText = document.querySelector('.mv_meta');
  const nameText = document.querySelector('.mv_name'); // 名前の要素

  const lineBar = document.querySelector('.mv_line_bar'); // 進行状況バーの要素
  const mvLast = document.querySelector('.mv_last'); // 最後に表示するロゴとテキストの要素

  if (imgs.length < 2) return;

  let currentIndex = 0;
  let dots = [];

  const isSafeUrl = (url) => {
    if (typeof url !== 'string') return '';
    return /^(https?:\/\/|\/|\.\/|\.\.\/)/i.test(url) ? url : '';
  };

  const restartCurrentBar = () => {
    if (!lineBar) return;
    lineBar.style.display = '';
    lineBar.classList.remove('is-active');
    void lineBar.offsetWidth; // リフロー発生
    lineBar.classList.add('is-active');
  };

  const createIndicators = () => {
    if (!indicatorArea) return;
    indicatorArea.innerHTML = '';

    items.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('mv_indicator_dot');
      dot.setAttribute('type', 'button');
      dot.setAttribute('aria-label', `Slide ${index + 1}`);

      dot.addEventListener('click', () => {
        goToSlide(index, false); // 手動クリックは即時切り替え
      });

      indicatorArea.appendChild(dot);
      dots.push(dot);
    });
  };

  const updateIndicator = (index) => {
    if (!dots.length) return;
    dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  };

  const resetImageState = (img) => {
    img.classList.remove('is-current', 'is-next');
    img.style.animation = '';
    img.style.animationPlayState = '';
    img.style.opacity = '';
    img.style.visibility = '';
  };

  const updateContent = (item) => {
    if (mvOverlayLink) {
      const safeLink = isSafeUrl(item.link || '');
      if (safeLink) {
        mvOverlayLink.href = safeLink;
        mvOverlayLink.dataset.href = safeLink;
        mvOverlayLink.style.pointerEvents = 'auto';
        mvOverlayLink.style.cursor = 'grab';
      } else {
        mvOverlayLink.removeAttribute('href');
        delete mvOverlayLink.dataset.href;
        mvOverlayLink.style.pointerEvents = 'none';
        mvOverlayLink.style.cursor = 'default';
      }
    }
    if (metaText) metaText.textContent = item.meta || '';
    if (nameText) nameText.textContent = item.name || '';
  };

  // 画像切り替えの変数
  let currentDomIndex = 0;
  let isFirstRender = true;
  let transitionTimeout = null;

  // スライドを描画する関数
  const renderSlide = (index, isAuto = false) => {
    currentIndex = Math.max(0, Math.min(index, items.length - 1));
    const currentItem = items[currentIndex];

    // 進行中のタイマーがあればリセット
    if (transitionTimeout) {
      clearTimeout(transitionTimeout);
      transitionTimeout = null;
    }

    if (mvLast) {
      mvLast.classList.remove('is-show', 'is-clear');
      if (indicatorArea) indicatorArea.classList.remove('is-last-view');
    }

    if (!isFirstRender) {
      currentDomIndex = 1 - currentDomIndex;
    }
    const activeImg = imgs[currentDomIndex];
    const oldImg = imgs[1 - currentDomIndex];

    isFirstRender = false;

    resetImageState(oldImg);

    // 画面幅に応じてPC用/SP用画像を出し分ける
    const isSp = window.innerWidth <= 768;
    const imageUrl = isSp && currentItem.image_sp ? currentItem.image_sp : currentItem.image;

    activeImg.setAttribute('src', isSafeUrl(imageUrl));
    activeImg.alt = currentItem.name || '';

    void activeImg.offsetWidth;
    activeImg.classList.add('is-current');

    updateContent(currentItem);
    updateIndicator(currentIndex);

    const isLast = (currentIndex === items.length - 1);

    if (isLast) {
      // 最後のスライド
      activeImg.style.opacity = '1';
      activeImg.style.visibility = 'visible';
    }

    if (isAuto) {
      // 自動遷移の場合：フェード完了後に次のバーを再スタート
      transitionTimeout = setTimeout(() => {
        restartCurrentBar();
      }, 1200);
    } else {
      // ドットやスワイプの手動操作の場合：すぐ次のバーをスタート
      restartCurrentBar();
    }


  };

  const goToSlide = (index, isAuto = false) => {
    renderSlide(index, isAuto);
  };

  const nextSlide = (isAuto = false) => {
    if (currentIndex >= items.length - 1) return;
    goToSlide(currentIndex + 1, isAuto);
  };

  const prevSlide = () => {
    if (currentIndex <= 0) return;
    goToSlide(currentIndex - 1, false);
  };

  // --- 初期化処理 ---
  createIndicators();
  goToSlide(0, false);

  if (lineBar) {
    lineBar.addEventListener('animationend', (event) => {
      if (event.animationName === 'barProgress') {
        if (currentIndex < items.length - 1) {
          nextSlide(true);
        } else {
          // 最後のスライドのバーが最後まで到達した時の処理
          if (mvLast) {
            mvLast.classList.add('is-show'); // フェードイン開始

            if (indicatorArea) indicatorArea.classList.add('is-last-view');

            dots.forEach(dot => dot.classList.remove('is-active'));

            // 1.5秒後（フェードイン完了タイミング）にぼかしを解除
            setTimeout(() => {
              mvLast.classList.add('is-clear');
            }, 1500);
          }
        }
      }
    });
  }

  // ==========================================
  // --- ウィンドウリサイズ時の画像切り替え ---
  // ==========================================
  window.addEventListener('resize', () => {
    const isSp = window.innerWidth <= 768;
    const currentItem = items[currentIndex];
    const imageUrl = isSp && currentItem.image_sp ? currentItem.image_sp : currentItem.image;

    const activeImg = imgs[currentDomIndex];
    const safeUrl = isSafeUrl(imageUrl);

    // 現在のスライド画像がPC用/SP用の切り替えで変わる場合のみ更新
    if (activeImg && activeImg.getAttribute('src') !== safeUrl) {
      activeImg.setAttribute('src', safeUrl);
    }
  });

  // ==========================================
  // --- スワイプ ＆ ドラッグ ---
  // ==========================================
  const swipeThreshold = 50;
  let startX = 0;
  let startY = 0;
  let isInteracting = false;
  let hasMoved = false;

  imgs.forEach(img => {
    img.addEventListener('dragstart', (e) => e.preventDefault());
  });

  const handleStart = (clientX, clientY) => {
    isInteracting = true;
    hasMoved = false;
    startX = clientX;
    startY = clientY;
    if (mvOverlayLink) mvOverlayLink.style.cursor = 'grabbing';
  };

  const handleMove = (clientX, clientY) => {
    if (!isInteracting) return;
    const diffX = clientX - startX;
    if (Math.abs(diffX) > 10) {
      hasMoved = true;
    }
  };

  const handleEnd = (clientX, clientY) => {
    if (!isInteracting) return;
    isInteracting = false;
    if (mvOverlayLink) mvOverlayLink.style.cursor = 'grab';

    const diffX = clientX - startX;
    const diffY = clientY - startY;

    if (Math.abs(diffX) >= swipeThreshold && Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX < 0) {
        nextSlide(false); // 手動スワイプ
      } else {
        prevSlide();
      }
    }
  };

  mvArea.addEventListener('touchstart', (e) => {
    const touch = e.touches[0];
    if (touch) handleStart(touch.clientX, touch.clientY);
  }, { passive: true });

  mvArea.addEventListener('touchmove', (e) => {
    const touch = e.touches[0];
    if (touch) handleMove(touch.clientX, touch.clientY);
  }, { passive: true });

  mvArea.addEventListener('touchend', (e) => {
    const touch = e.changedTouches[0];
    if (touch) handleEnd(touch.clientX, touch.clientY);
  }, { passive: true });

  mvArea.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;
    handleStart(e.clientX, e.clientY);
  });

  window.addEventListener('mousemove', (e) => {
    handleMove(e.clientX, e.clientY);
  });

  window.addEventListener('mouseup', (e) => {
    handleEnd(e.clientX, e.clientY);
  });

  if (mvOverlayLink) {
    mvOverlayLink.addEventListener('click', (event) => {
      if (hasMoved) {
        event.preventDefault();
        event.stopPropagation();
        hasMoved = false;
        return;
      }
      const url = event.currentTarget.dataset.href;
      if (url && event.currentTarget.tagName.toLowerCase() !== 'a') {
        window.location.href = url;
      }
    });
  }
});

/*----------------------------------------
カレント
------------------------------------------*/
// if (body.classList.contains("home")) {
//   (function() {
//     window.addEventListener('DOMContentLoaded', () => {
//       const allLinks = document.querySelectorAll('.hd_nav_link');
//       const currentClass = 'is_active';
//       const path = window.location.pathname;

//       const aboutLink = document.querySelector('.hd_nav_list:nth-of-type(1) .hd_nav_link');
//       const worksLink = document.querySelector('.hd_nav_list:nth-of-type(2) .hd_nav_link');
//       const strengthLink = document.querySelector('.hd_nav_list:nth-of-type(3) .hd_nav_link');
//       const partnershipLink = document.querySelector('.hd_nav_list:nth-of-type(4) .hd_nav_link');
//       const contactLink = document.querySelector('.hd_nav_list:nth-of-type(6) .hd_nav_link');

//       const resetActive = () => allLinks.forEach(link => link.classList.remove(currentClass));

//       const isTopPage = path === '/' || path.endsWith('/') || path.includes('index');

//       if (!isTopPage) {
//         resetActive();
//         if (path.includes('aboutus')) aboutLink?.classList.add(currentClass);
//         if (path.includes('works')) worksLink?.classList.add(currentClass);
//         if (path.includes('strength')) strengthLink?.classList.add(currentClass);
//         if (path.includes('partnership')) partnershipLink?.classList.add(currentClass);
//         if (path.includes('contact')) contactLink?.classList.add(currentClass);
//       }


//       allLinks.forEach(link => {
//         link.addEventListener('click', () => {
//           resetActive();
//           link.classList.add(currentClass);
//         });
//       });

//       const observerOptions = {
//         root: null,
//         rootMargin: '-30% 0px -30% 0px',
//         threshold: 0
//       };

//       const observer = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {

//             resetActive();
//             if (entry.target.id === 'aboutus') aboutLink?.classList.add(currentClass);
//             if (entry.target.id === 'works') worksLink?.classList.add(currentClass);
//             if (entry.target.id === 'strength') strengthLink?.classList.add(currentClass);
//             if (entry.target.id === 'partnership') partnershipLink?.classList.add(currentClass);
//             if (entry.target.id === 'contact') contactLink?.classList.add(currentClass);
//           } else {

//             if (entry.target.id === 'aboutus') aboutLink?.classList.remove(currentClass);
//             if (entry.target.id === 'works') worksLink?.classList.remove(currentClass);
//             if (entry.target.id === 'strength') strengthLink?.classList.remove(currentClass);
//             if (entry.target.id === 'partnership') partnershipLink?.classList.remove(currentClass);
//             if (entry.target.id === 'contact') contactLink?.classList.remove(currentClass);
//           }
//         });
//       }, observerOptions);

//       const sections = ['aboutus', 'works', 'strength', 'partnership', 'contact'];
//       sections.forEach(id => {
//         const element = document.getElementById(id);
//         if (element) observer.observe(element);
//       });

//     });
//   })();
// }

/*----------------------------------------
要素アニメーション
------------------------------------------*/
const item = document.querySelectorAll('.scrollAnim');
item.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 80%",
    onEnter: () => target.classList.add('active'), // その要素自身にクラスを付ける
  });
});


/*----------------------------------------
OPアニメーション
------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const loading = document.querySelector(".loading");

  const firstVisit = sessionStorage.getItem("firstVisit") !== "done";

  if (firstVisit) {
    setTimeout(() => {
      if (loading) loading.remove();
    }, 5000);

    // 訪問済みフラグをセット
    sessionStorage.setItem("firstVisit", "done");

  } else {
    // ----------------------------------------------
    // 【2回目以降】オープニングをスキップして即座に削除
    // ----------------------------------------------
    if (loading) loading.remove();
  }
});

/*------------------------------------------------
ヘッダー　動き
--------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {

  const header = document.getElementById('header');

  if (!header) return;

  let lastScrollY = window.scrollY;

  const checkHeader = () => {
    // 画面幅1024px以下の時は無効化（クラスを消去して処理をスキップ）
    if (window.innerWidth <= 1024) {
      header.classList.remove('is-active', 'is-hidden');
      return;
    }

    const currentScrollY = window.scrollY;

    // 先頭付近では初期表示（透明・表示）
    if (currentScrollY <= 0) {
      header.classList.remove('is-active');
      header.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      return;
    }

    // 少しでもスクロールしたら白帯を表示
    header.classList.add('is-active');

    // 下スクロールで隠す / 上スクロールで表示
    if (currentScrollY > lastScrollY) {
      header.classList.add('is-hidden');
    } else if (currentScrollY < lastScrollY) {
      header.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  };

  // 初期実行（リロード時対策）
  checkHeader();

  // スクロールイベント
  window.addEventListener('scroll', checkHeader, { passive: true });

  // 画面リサイズ時にも判定を実行（PC/スマホ切り替え対策）
  window.addEventListener('resize', checkHeader, { passive: true });
});